import dayjs from '../../../utils/dayjsConfig'
import { effectiveLocationStr, formatTimetoHHmm } from '../../../helpers/utils'
import { getTimestampCardSubtitle } from './cardCopy'

export const buildTimestampControlKpis = (summary = {}, isSameDay, hasData = true) => {
  const metrics = !hasData
    ? [
        ['Hora de primera visita', '-'],
        ['Hora de última visita', '-'],
        ['Duración total de visitas', '-']
      ]
    : isSameDay
      ? [
          ['Hora de primera visita', formatTimetoHHmm(summary.first_visit_time)],
          ['Hora de última visita', formatTimetoHHmm(summary.last_visit_time)],
          ['Duración total de visitas', summary.total_visit_duration || '-']
        ]
      : [
          ['Hora de primera visita', 'N/A'],
          ['Hora de última visita', 'N/A'],
          ['Tiempo promedio de visita', summary.average_visit_duration || '-']
        ]
  return metrics.map(([title, value]) => ({
    title,
    value,
    footer: getTimestampCardSubtitle({ title, isSameDay }) || ''
  }))
}

const mapUrl = (latitude, longitude) => {
  if (
    latitude == null ||
    longitude == null ||
    String(latitude).trim() === '' ||
    String(longitude).trim() === ''
  )
    return ''
  const lat = Number(latitude)
  const lng = Number(longitude)
  return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180
    ? `https://www.google.com/maps?q=${lat},${lng}`
    : ''
}

export const buildTimestampControlRows = (results = []) =>
  results.map((row) => {
    const completed = row.status === 'completed'
    const date = row.visited_date ? dayjs(row.visited_date) : null
    return {
      raw: row,
      completed,
      date: date?.isValid() ? date.format('DD/MM/YYYY') : '-',
      client: row.client_name || '-',
      start: formatTimetoHHmm(row.start_visit_time),
      end: completed ? formatTimetoHHmm(row.end_visit_time) : 'En curso',
      duration: completed ? row.visit_duration || '-' : '-',
      geofence:
        row.effective_location != null
          ? effectiveLocationStr(row.effective_location, row.client_latitude, row.start_latitude)
          : 'N/A',
      startUrl: mapUrl(row.start_latitude, row.start_longitude),
      endUrl: completed ? mapUrl(row.end_latitude, row.end_longitude) : ''
    }
  })
